(() => {
  modalBeforeInit();

  document.addEventListener('readystatechange', e => e.target.readyState === 'complete' && modalsInit());
})();

const KEYCODE_TAB = 9;
const KEYCODE_ENTER = 13;
const KEYCODE_ESC = 27;
let currentFocus;

function trapFocus(element) {
  let focusable = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), select:not([disabled]), .modal__close:not([disabled]):not(.modal__background), label:not([disabled])');
  let first = focusable[0];
  let last = focusable[focusable.length - 1];

  if (focusable) {
    focusable[element.dataset.videoId || focusable.length === 1 ? 0 : 1].focus();

    focusable.forEach((el, index) => {
      if (el.tagName != 'A' && el.tagName != 'BUTTON' && el.tagName != 'TEXTAREA' && el.tagName != 'INPUT' && el.getAttribute("tabindex") == null) {
        el.setAttribute('tabindex', 0);
      }
      el.addEventListener('keydown', e => (e.key === 'Enter' || e.keyCode === KEYCODE_ENTER) && el.click());
    });
  } 

  element.addEventListener('keydown', e => {
    let isTab = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
    if (!isTab) return;

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus(); /* shift + tab */
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus(); /* tab */
    }
  });
}

function modalBeforeInit() {
  document.querySelectorAll('*:not(body) .modal').forEach(modal => {
    document.body.appendChild(modal);
  });
}

function modalsInit() {
  const body = document.body;
  const main = document.querySelector('.page');
  const modalOpeners = document.querySelectorAll('[data-modal-open]:not(.ready)');
  main.setAttribute('aria-hidden', 'false');

  const getPlayer = (videoId) => videojs && videojs(videoId);
  const getModal = (id) => document.querySelector('[data-modal-id="' + id + '"]');
  const modalClose = (target) => {
    target.classList.remove('modal-opened');
    body.classList.remove('overlay-visible');
    target.setAttribute('aria-hidden', 'true');
    main.setAttribute('aria-hidden', 'false');
    currentFocus.focus();

    target.dataset.videoId && getPlayer(target.dataset.videoId).pause();
  }
  const modalOpen = (target, current) => {
    target.classList.add('modal-opened');
    body.classList.add('overlay-visible');
    target.setAttribute('aria-hidden', 'false');
    main.setAttribute('aria-hidden', 'true');

    trapFocus(target);
    currentFocus = current;
    target.dataset.videoId && getPlayer(target.dataset.videoId).play();
  }

  if (modalOpeners) {
    modalOpeners.forEach(item => {
      item.classList.add('ready');
      let modal = getModal(item.dataset.modalTarget);

      if (modal !== null) {
        modal.classList.add('ready');
        let closes = modal.querySelectorAll('[data-modal-close]');
        closes.forEach(close => {
          close.addEventListener('click', e => {
            modalClose(modal);

            e.stopPropagation();
          }, false);

          close.addEventListener('keydown', e => e.key === 'Enter' || e.keyCode === KEYCODE_ENTER && modalClose(modal, item));
        });

        item.addEventListener('click', () => modalOpen(modal, item));
        item.addEventListener('keydown', e => e.key === 'Enter' || e.keyCode === KEYCODE_ENTER && modalOpen(modal, item));
        item.addEventListener('keydown', e => {
          if (e.key === ' ' || e.keyCode === KEYCODE_SPACE) {
            e.preventDefault();
            modalOpen(modal, item);
          }
        });

        document.addEventListener('keydown', e => {
          if (modal.classList.contains('modal-opened') && (e.key === 'Escape' || e.keyCode === KEYCODE_ESC)) modalClose(modal, item);

          e.stopPropagation();
        });
      }
    });
  }
}
